/* eslint-disable react/no-unstable-nested-components */
import { useState, useContext } from 'react';

// eslint-disable-next-line no-unused-vars
import styled from 'styled-components/macro';
import { FiltersContext } from 'context/filtersContext';
import { AuthContext } from 'context/authContext';
import { format, formatDistanceToNow } from 'date-fns';
import { getDateObject } from 'helpers/common';
import notificationService from 'services/notificationService';
import {
  NoficationHolder,
  Notification,
  NotificationDropDown,
  NotificationList,
  ListBox,
} from './NotificationBox.styles';

function NotificationBox() {
  const { setOverlay, overlay } = useContext(FiltersContext);
  const { notifications, setNotifications } = useContext(AuthContext);
  const [isOpen, setIsOpen] = useState(false);
  const colors = ['#40ddff', '#cd39e3', '#FFB730'];

  const dateFormater = date => {
    let formatedDate;
    const now = formatDistanceToNow(new Date(date));
    if (now === 'less than a minute' || now === '1 minute') {
      formatedDate = 'Just Now';
    } else if (now.split(' ')[1] === 'minutes') {
      formatedDate = 'Few minutes ago';
    } else if (now === 'about 1 hour') {
      formatedDate = '1 Hour Ago';
    } else {
      formatedDate = format(getDateObject(date), 'MMM do yyyy');
    }
    return formatedDate;
  };
  console.log({ notifications });
  const markRead = async checked => {
    const ids = [];
    if (checked) {
      notifications.map(_ => {
        if (_.isRead === false) {
          ids.push(_._id);
        }
        return '';
      });
      if (ids.length) {
        await notificationService
          .markAsRead(ids)
          .then(async res => {
            if (res.success) {
              setIsOpen(false);
              setOverlay(false);
              await notificationService
                .getNotifications()
                .then(response => {
                  setNotifications(response?.notifications);
                })
                .catch(() => {});
            }
          })
          .catch(() => {});
      }
    }
  };

  return (
    <NoficationHolder>
      <Notification
        onClick={() => {
          setIsOpen(!isOpen);
          setOverlay(!overlay);
        }}>
        <span className="icon-bell" />
        {notifications?.length}
      </Notification>
      <NotificationDropDown dropdownOpen={isOpen}>
        <div className="header">
          <strong className="heading">Notifications</strong>
          {notifications?.length > 0 && (
            <label htmlFor="check" className="check-mark">
              <input id="check" type="checkbox" onChange={e => markRead(e.target.checked)} />
              <span className="label-text">Mark all as Read</span>
            </label>
          )}
        </div>
        <NotificationList height={300}>
          {notifications?.length > 0 ? (
            notifications.map((_, index) => {
              const color = colors[index % 3];
              return (
                <ListBox borderColor={color}>
                  <strong className="title">
                    <span className="ico material-icons-outlined">bolt</span>
                    {_?.title}
                  </strong>
                  <ul className="list">
                    <li>
                      <span className="text">{_.message}</span>
                      <span className="date">{notifications?.length > 0 ? dateFormater(_?.created_at) : '----'}</span>
                    </li>
                  </ul>
                </ListBox>
              );
            })
          ) : (
            <span className="empty-text">no notification</span>
          )}
        </NotificationList>
      </NotificationDropDown>
    </NoficationHolder>
  );
}

export default NotificationBox;
